import { render, staticRenderFns } from "./TicketViewer.vue?vue&type=template&id=4c4a9962&scoped=true"
import script from "./TicketViewer.vue?vue&type=script&lang=js"
export * from "./TicketViewer.vue?vue&type=script&lang=js"
import style0 from "./TicketViewer.vue?vue&type=style&index=0&id=4c4a9962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a9962",
  null
  
)

export default component.exports